import { render, staticRenderFns } from "./order-mail.vue?vue&type=template&id=34163d9f"
import script from "./order-mail.vue?vue&type=script&lang=js"
export * from "./order-mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports